import RefreshIcon from '@/CustomIcons/RefreshIcon'
import ElectronIPC from '../../services/ElectronIPC'
import { Button } from '@/UIComponents2/Button'

export default function MaintenanceError({ message }: { message: string }) {
    return (
        <div className="flex flex-col h-full items-center justify-center">
            <div className="px-8 md:max-w-[600px]">
                <div className="text-xl font-semibold pb-6">Maintenance</div>
                <div className="text-sm pb-2">We are currently undergoing maintenance.</div>
                <pre className="text-sm mb-5 whitespace-pre-wrap">{message}</pre>
                <Button variant="link" onClick={() => ElectronIPC.reload()}>
                    <div className="flex items-center gap-1">
                        <span>Retry</span>
                        <RefreshIcon className="py-[2px]" />
                    </div>
                </Button>
            </div>
        </div>
    )
}
